const mapping = [{
    label: 'Did you remove all loose paper and debris?',
    key: 'debris'
}, {
    label: 'Did you walk around and notice any visible signs fluids leaks or damage?',
    key: 'fluids'
}, {
    label: 'Are the tires in good condition?',
    key: 'tires'
}, {
    label: 'Are the propane fuel tank, valves, and hoses in good condition?',
    key: 'fuelTankValuesHoses'
}, {
    label: 'Is the fire extinguisher properly mounted, seal and gauge in good condition?',
    key: 'fireExtinguisher'
}, {
    label: 'Are the battery and cables in good condition?',
    key: 'battery'
}, {
    label: 'Are seatbelts in good working condition?',
    key: 'seatbelts'
}, {
    label: 'Are the wipers in good working condition?',
    key: 'wipers'
}, {
    label: 'Are the lights, horn, gauges and reverse warning system working?',
    key: 'lightsHornGauges'
}, {
    label: 'Is the steering system working?',
    key: 'steering'
}, {
    label: 'Are the brakes and parking brake in good condition and hold?',
    key: 'brakes'
}];

export default mapping;